export default {
    name: [
      { required: true, message: 'O nome é obrigatório.', trigger: 'blur' },
      { min: 5, max: 100, message: 'O nome deve ter entre 5 e 100 caracteres.', trigger: 'blur' }
    ],
  }
  